import _regeneratorRuntime from 'babel-runtime/regenerator';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import _Promise from 'babel-runtime/core-js/promise';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import { mapState } from 'vuex';
import creativePreviewer from '@pt/components/creative-previewer/index';
import EditCreative from '@/views/creative/components/creative-info/edit-creative.vue';
// import AutoTips from '@/components/AutoTips'
import _ from 'lodash';
import { createPSProject, getPSProjectInfo } from '@ps/api/project';
import SkinPreviewerList from '@pt/views/common-template/components/skin-previewer-list.vue';

export default {
  components: {
    SkinPreviewerList: SkinPreviewerList,
    creativePreviewer: creativePreviewer,
    EditCreative: EditCreative
    // AutoTips,
  },
  props: {
    previewType: {
      type: String,
      default: 'template'
    },
    showCollectIcon: {
      type: Boolean,
      default: true
    },
    projectType: [String],
    currentPreviewItem: [Object],
    previewRequest: [Function, String],
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    skinList: {
      type: Array
    },
    skinId: {
      type: Number
    },
    pageType: {
      type: String
    },
    creativePreviewerDialog: [Object],
    creativePreviewer: [Object]
  },
  data: function data() {
    return {
      previewRequestUrl: '',
      previewLoading: false
    };
  },

  computed: _extends({}, mapState({
    userInfo: function userInfo(state) {
      return state.user.info;
    },
    // creativePreviewerDialog: (state) =>
    //   state.pt.delivery.creativePreviewerDialog,
    // creativePreviewer: (state) => state.pt.delivery.creativePreviewer,
    is_allow_ps: function is_allow_ps(state) {
      return state.user.info.is_allow_ps;
    }
  }), {
    has_gmaker: function has_gmaker() {
      return this.$store.getters.gm.allow;
    },


    // 是否允许通用模板编辑
    canGmaker: function canGmaker() {
      return this.has_gmaker;
    },


    // 是否允许自由编辑 - 3D模型不展示自由制作
    canFreeEdit: function canFreeEdit() {
      return this.currentPreviewItem.is_support_ps === 1 && this.is_allow_ps === 1 && this.currentPreviewItem.dimension_type !== 3;
    },
    previewInfo: function previewInfo() {
      return _extends({
        desc: ''
      }, creativePreviewer.info);
    },
    previewerCreatives: function previewerCreatives() {
      // 单个预览素材，通过异步接口获取预览地址
      if (this.creativePreviewer.creatives.length === 1 && this.previewRequestUrl) {
        return [_extends({}, this.creativePreviewer.creatives[0], {
          preview_url: this.previewRequestUrl
        })];
      }
      return this.creativePreviewer.creatives;
    },
    cannotNext: function cannotNext() {
      var _this = this;

      return this.data.findIndex(function (item) {
        return item.id === _this.currentPreviewItem.id;
      }) === this.data.length - 1;
    },
    cannotPrev: function cannotPrev() {
      var _this2 = this;

      return this.data.findIndex(function (item) {
        return item.id === _this2.currentPreviewItem.id;
      }) === 0;
    },


    creativePreviewerDialogVisible: {
      get: function get() {
        return this.creativePreviewerDialog.visible;
      },
      set: function set() {
        this.$emit('cancel');
        // this.$store.commit('pt/delivery/closeCreativePreviewerDialog')
      }
    }
  }),
  methods: {
    handleEdit: function handleEdit() {
      this.$emit('edit', this.currentPreviewItem);
    },
    handleFreeEdit: function handleFreeEdit() {
      this.handleCommand('free');
    },
    handleCommand: function handleCommand(command) {
      var param = {
        id: this.currentPreviewItem.id,
        type: command
      };
      param.skinId = this.skinId;
      console.log('创建皮肤', this.skinId);
      this.$emit('create', param);
    },
    handleCopySuccess: function handleCopySuccess() {
      this.$emit('copy-success');
    },
    handleNext: function handleNext(item) {
      if (this.cannotNext) return;
      this.$emit('nextPreview', item);
    },
    handlePrev: function handlePrev(item) {
      if (this.cannotPrev) return;
      this.$emit('prevPreview', item);
    },
    handleStar: function handleStar(item) {
      this.$emit('star', item);
    },
    handleCopyPSTmpl: function handleCopyPSTmpl(params) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, code, errorMsg, _$get, id;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                params.source = 'ps';
                _context.next = 4;
                return createPSProject(params);

              case 4:
                res = _context.sent;
                code = _.get(res, 'code');

                if (!(code === 1)) {
                  _context.next = 12;
                  break;
                }

                errorMsg = _.get(res, 'msg');

                _this3.$message.error(errorMsg);
                return _context.abrupt('return', _Promise.reject(_Object$assign({}, res, { message: errorMsg })));

              case 12:
                if (!(code === 0)) {
                  _context.next = 15;
                  break;
                }

                _$get = _.get(res, 'data'), id = _$get.id;
                // 根据 pt 格式拼接返回参数

                return _context.abrupt('return', {
                  data: {
                    data: {
                      project_id: id
                    }
                  }
                });

              case 15:
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](0);

                console.error(_context.t0);

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 17]]);
      }))();
    },
    getPSProjectInfoByProjectId: function getPSProjectInfoByProjectId(projectId) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getPSProjectInfo({
                  id: projectId.project_id
                });

              case 2:
                res = _context2.sent;
                return _context2.abrupt('return', { data: res });

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    getPreviewUrl: function getPreviewUrl() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var res;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this5.previewLoading = true;
                _context3.next = 4;
                return _this5.previewRequest({
                  id: _this5.creativePreviewer.custom_id
                });

              case 4:
                res = _context3.sent;

                _this5.previewLoading = false;
                _this5.previewRequestUrl = _.get(res, 'data.data.preview_url') || _.get(res, 'data.preview_url');
                _context3.next = 13;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](0);

                _this5.previewLoading = false;
                console.log(_context3.t0);

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 9]]);
      }))();
    },
    changeSkinId: function changeSkinId(skin_id) {
      console.log(skin_id);
      this.$emit('update:skinId', skin_id);
    },
    getSkinPreviewUrl: function getSkinPreviewUrl() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this6.previewLoading = true;
                _context4.next = 4;
                return _this6.previewRequest({
                  id: _this6.creativePreviewer.source_id,
                  skin_id: _this6.skinId
                });

              case 4:
                res = _context4.sent;

                _this6.previewLoading = false;
                _this6.previewRequestUrl = _.get(res, 'data.data.preview_url') || _.get(res, 'data.preview_url');
                _context4.next = 13;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](0);

                _this6.previewLoading = false;
                console.log(_context4.t0);

              case 13:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 9]]);
      }))();
    }
  },
  watch: {
    'creativePreviewer.custom_id': function creativePreviewerCustom_id(val) {
      if (val) {
        this.previewRequestUrl = '';
        if (this.previewRequest) {
          this.getPreviewUrl();
        }
      }
    },
    skinId: function skinId(val) {
      if (val) {
        this.previewRequestUrl = '';
        if (this.previewRequest && this.pageType !== 'myTemplate') {
          this.getSkinPreviewUrl();
        }
      }
    }
  }
};